export const site_survey_questions = [
  {
    step: "landing",
    fields: [
      {
        type: "dropdown",
        id: "landingCallStation",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingCallStation",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "landingDisplay",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingDisplay",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "landingDoor",
        options: [
          "AUTOMATIC",
          "MANUAL"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingDoor",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "landingPanel",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingPanel",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "landingSill",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingSill",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "landingDoorClosing",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingDoorClosing",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "landingAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "landingPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "landingPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "car",
    fields: [
      {
        type: "dropdown",
        id: "carCurtainOfLightPhotocell",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carCurtainOfLightPhotocell",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carDoorPanel",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carDoorPanel",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carPushButton",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carPushButton",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carDisplay",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carDisplay",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "image",
        id: "carPictureCopKen",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carPictureCopKen",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carMirrorV2",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carMirrorV2",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carHandrailV2",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carHandrailV2",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carWallPanelsV2",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carWallPanelsV2",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carLightingV2",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carLightingV2",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carFloorV2",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carFloorV2",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carSill",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carSill",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carAlarmPhone",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carAlarmPhone",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "carFan",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carFan",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        id: "carAdditionalComments",
        translationKey: "additionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "carPictureGeneral",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "carPictureGeneral",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "machineryArea",
    fields: [
      {
        type: "dropdown",
        id: "machineryAreaOSG",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaOSG",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryAreaLighting",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaLighting",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryAreaTemperatureImpactingElevatorOperation",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaTemperatureImpactingElevatorOperation",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryAreaAccessSafety",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaAccessSafety",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryAreaMachineGuards",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaMachineGuards",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryAreaHandrails",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaHandrails",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "machineryAreaAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "machineryAreaPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryAreaPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "machinery",
    fields: [
      {
        type: "dropdown",
        id: "machineryType",
        options: [
          "GEARED",
          "GEARLESS",
          "HYDRAULIC"
        ]
      }
    ]
  },
  {
    step: "machineryGeared",
    requiresKey: "machineryType",
    requiresValue: "GEARED",
    fields: [
      {
        type: "dropdown",
        id: "machineryGearedBrake",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearedBrake",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryGearedOilReplacement",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearedOilReplacement",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryGearedTractionSheave",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearedTractionSheave",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryGearedOilHeater",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearedOilHeater",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryGearedCylinderSeal",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearedCylinderSeal",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "machineryGearedAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "machineryGearedPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearedPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "machineryGearless",
    requiresKey: "machineryType",
    requiresValue: "GEARLESS",
    fields: [
      {
        type: "dropdown",
        id: "machineryGearlessBrake",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearlessBrake",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryGearlessTractionSheave",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearlessTractionSheave",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "machineryGearlessAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "machineryGearlessPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryGearlessPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "machineryHydraulic",
    requiresKey: "machineryType",
    requiresValue: "HYDRAULIC",
    fields: [
      {
        type: "dropdown",
        id: "machineryHydraulicOilReplacement",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryHydraulicOilReplacement",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryHydraulicValve",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryHydraulicValve",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryHydraulicOilCooler",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryHydraulicOilCooler",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryHydraulicOilHeater",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryHydraulicOilHeater",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "machineryHydraulicCylinderSeal",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryHydraulicCylinderSeal",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "machineryHydraulicAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "machineryHydraulicPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "machineryHydraulicPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "controller",
    fields: [
      {
        type: "image",
        id: "controllerTakePictureOfWholeControllerIncludeCPU",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "controllerTakePictureOfWholeControllerIncludeCPU",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text",
        id: "controllerName"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "controllerName",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "controllerModernization",
        options: [
          "MODERNIZATION_NEEDED",
          "MODERNIZATION_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "controllerModernization",
        selectionConditions: [
          "MODERNIZATION_NEEDED"
        ]
      },
      {
        type: "date",
        id: "controllerLastInvertorReplacementDate",
        label: "Controller Last Invertor Replacement Date",
      },
      {
        type: "dropdown",
        id: "controllerContractors",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "controllerContractors",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "controllerAdditionalComments",
        helpText: "additionalCommentsHelpText"
      }
    ]
  },
  {
    step: "shaft",
    fields: [
      {
        type: "dropdown",
        id: "shaftCarDoorOperator",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCarDoorOperator",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftCarDoorMechanicalWearingPart",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCarDoorMechanicalWearingPart",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftLandingDoorMechanicalWearingPart",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftLandingDoorMechanicalWearingPart",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftLock",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftLock",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "image",
        id: "shaftCarDoorOperatorPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCarDoorOperatorPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftCoupler",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCoupler",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftHoistingRope",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftHoistingRope",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "date",
        id: "shaftHoistingRopeInstallationDate",
        label: "Shaft Hoisting Rope - Installation Date"
      },
      {
        type: "dropdown",
        id: "shaftTravellingCable",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftTravellingCable",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "date",
        id: "shaftTravellingCableInstallationDate",
        label: "Shaft Travelling Cable - Installation Date"
      },
      {
        type: "dropdown",
        id: "shaftCompensationRopeChain",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCompensationRopeChain",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftLubricator",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftLubricator",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftCar",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCar",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftCWT",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftCWT",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftDiverterPulley",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftDiverterPulley",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "shaftLighting",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftLighting",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "shaftAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "shaftPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "shaftPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "pit",
    fields: [
      {
        type: "number",
        id: "pitOSGTensionWeight",
        label: "OSG Tension Weight",
        min: 0,
        max: 9999999,
        maxLength: 7
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitOSGTensionWeight",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "pitLadderSafety",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitLadderSafety",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "pitStopButton",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitStopButton",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "pitLighting",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitLighting",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "pitCarBuffer",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitCarBuffer",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "pitCWTBuffer",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitCWTBuffer",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "dropdown",
        id: "pitOilCollector",
        options: [
          "REPAIR_NEEDED",
          "REPAIR_NOT_NEEDED"
        ]
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitOilCollector",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      },
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "pitAdditionalComments",
        helpText: "additionalCommentsHelpText"
      },
      {
        type: "image",
        id: "pitPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      },
      {
        type: "conditionalComponent",
        component: "planner-lead",
        id: "plannerLeadHeader",
        selectionConditionId: "pitPicture",
        selectionConditions: [
          "REPAIR_NEEDED"
        ]
      }
    ]
  },
  {
    step: "additionalObservations",
    fields: [
      {
        type: "text-area",
        translationKey: "additionalComments",
        id: "additionalObservationsAdditionalComments",
        helpText: "additionalObservationsHelpText"
      },
      {
        type: "image",
        id: "additionalObservationsPicture",
        showTitle: true,
        instructionText: "fiveFileLimitHelpText"
      }
    ]
  }
];